import React, { useState } from "react";
import theme from "../../Styles/theme";
import { Container, HandleInput, Input, HandleButton, Button } from "./styles";
import Modal from "react-modal";
import { ModalDivX } from "../ModalDivX";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { DarkButton } from "../DarkButton";
import { ICartorio, useCartorio } from "../../Hooks/cartorio";
import {
  IFuncionarioCartorio,
  useFuncionarioCartorio,
} from "../../Hooks/funcionarioCartorio";
import { ModalLoader } from "../ModalLoader";
import { Alert } from "../Error/Alert";
import api from "../../Services/api";
import { IPrefeitura, usePrefeitura } from "../../Hooks/usePrefeitura";
import { IFuncionarioPrefeitura, useFuncionarioPrefeitura } from "../../Hooks/funcionarioPrefeitura";
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: theme.colors.secondary,
    minWidth: "40%",
    maxWidth: "80%",
    borderRadius: "0.25rem",
  },
};

interface Props {
  open: boolean;
  onClose(): void;
  funcionarioCartorio?: IFuncionarioCartorio;
  funcionarioPrefeitura?: IFuncionarioPrefeitura;
  cartorio?: ICartorio;
  prefeitura?: IPrefeitura;
}

export function EditarSenhaModal({
  open,
  onClose,
  funcionarioCartorio,
  funcionarioPrefeitura,
  cartorio,
  prefeitura,
}: Props) {
  function handleClose() {
    onClose();
  }
  const { handleSetFuncionarioCartorio } = useFuncionarioCartorio();
  const { handleSetCartorio } = useCartorio();
  const{handleSetFuncionarioPrefeitura} = useFuncionarioPrefeitura();
  const [loading, setLoading] = useState(false); 
  const [SENHA, setSENHA] = useState("");
  const [confirmarSenha, setConfirmarSenha] = useState("");
  const [ver1, setVer1] = useState(false);
  const [ver2, setVer2] = useState(false);
  const [error, setError] = useState({ message: "", title: "" });
const{handleSetPrefeitura} = usePrefeitura();
  function validateSenhas() {
    if (SENHA.length == 0) {
      setError({
        message: "A senha digitada não deve ser vazia!",
        title: "Senhas Vazia!",
      });
      return false;
    }
    if (SENHA != confirmarSenha) {
      setError({
        message: "As senhas digitadas devem ser iguais!",
        title: "Senhas não conferem!",
      });
      return false;
    }

    return true;
  }

  async function post() {
    if (validateSenhas()) {
      try {
        setLoading(true);

        if (cartorio) {
          const { data } = await api.put(`/cartorio/update`, {
            NOME: cartorio.NOME,
            CPF_CNPJ: cartorio.CPF_CNPJ,
            EMAIL: cartorio.EMAIL,
            WHATS: cartorio.WHATS,
            SENHA: SENHA,
            ID: cartorio.ID,
          });

          handleSetCartorio(data);
        }

        if (funcionarioCartorio) {
          const { data } = await api.put(`/funcionario-cartorio/update`, {
            NOME: funcionarioCartorio.NOME,
            CPF: funcionarioCartorio.CPF,
            EMAIL: funcionarioCartorio.EMAIL,
            WHATS: funcionarioCartorio.WHATS,
            SENHA: SENHA,
            CARTORIO_ID: funcionarioCartorio.CARTORIO_ID,
            ID: funcionarioCartorio.ID,
            ATIVO: funcionarioCartorio.ATIVO,
          });

          handleSetFuncionarioCartorio(data);
        }

        if (prefeitura) {
          const { data } = await api.put(`/prefeitura/${prefeitura.ID}`, {
            NOME: prefeitura.NOME,

            SENHA: SENHA,

            ID: prefeitura.ID,
          });

          handleSetPrefeitura(data);
        }

        if(funcionarioPrefeitura){
          const { data } = await api.put(`/funcionario-prefeitura/update`, {
            NOME: funcionarioPrefeitura.NOME,
            CPF: funcionarioPrefeitura.CPF,
            EMAIL: funcionarioPrefeitura.EMAIL,
            WHATS: funcionarioPrefeitura.WHATS,
            SENHA: SENHA,
            PREFEITURA_ID: funcionarioPrefeitura.PREFEITURA_ID,
            ID: funcionarioPrefeitura.ID,
            ATIVO: funcionarioPrefeitura.ATIVO,
          });

          handleSetFuncionarioPrefeitura(data);
        }


      } catch (error) {
        setError({
          message:
            "Ocorreu algum erro ao tentar atualizar sua senha, tente novamente mais tarde!",
          title: "Ops",
        });
      } finally {
        setLoading(false);
        handleClose();
      }
    }

   

  }




  return (
    <Modal isOpen={open} onRequestClose={() => {}} style={customStyles}>
      <Container>
        <ModalDivX execute={onClose} />
        <HandleInput>
          <Input
            type={ver1 ? "text" : "password"}
            placeholder={"SENHA"}
            value={SENHA}
            onChange={(ev) => {
              setSENHA(ev.target.value);
            }}
          />
          {!ver1 ? (
            <FaEye
              onClick={() => setVer1(!ver1)}
              size={"max(13px, 1.5vw)"}
              style={{
                marginLeft: "1vw",
                color: theme.colors.dark,
                cursor: "pointer",
              }}
            />
          ) : (
            <FaEyeSlash
              onClick={() => setVer1(!ver1)}
              size={"max(13px, 1.5vw)"}
              style={{
                marginLeft: "1vw",
                color: theme.colors.dark,
                cursor: "pointer",
              }}
            />
          )}
        </HandleInput>
        <HandleInput>
          <Input
            type={ver2 ? "text" : "password"}
            placeholder={" CONFIRMAR SENHA"}
            value={confirmarSenha}
            onChange={(ev) => {
              setConfirmarSenha(ev.target.value);
            }}
          />
          {!ver2 ? (
            <FaEye
              onClick={() => setVer2(!ver2)}
              size={"max(13px, 1.5vw)"}
              style={{
                marginLeft: "1vw",
                color: theme.colors.dark,
                cursor: "pointer",
              }}
            />
          ) : (
            <FaEyeSlash
              onClick={() => setVer2(!ver2)}
              size={"max(13px, 1.5vw)"}
              style={{
                marginLeft: "1vw",
                color: theme.colors.dark,
                cursor: "pointer",
              }}
            />
          )}
        </HandleInput>
        <HandleButton>
          <Button
            onClick={() => {
              handleClose();
            }}
          >
            CANCELAR
          </Button>
          <Button onClick={post}>CONFIRMAR</Button>
        </HandleButton>

        <ModalLoader loading={loading} />
        <Alert
          title={error.title}
          message={error.message}
          open={error.message.length > 0}
          onClose={() => setError({ message: "", title: "" })}
        />
      </Container>
    </Modal>
  );
}
